import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { api } from './services/api'
import { authProviderApi } from './services/authProviderApi'
import { migrationApi } from './services/migrationApi'
import { quickPartsApi } from './services/quickPartsApi'
import appReducer from './slices/appSlice'
import contactsReducer from './slices/contactsSlice'
import customersReducer from './slices/customersSlice'
import cuttingTechnologiesReducer from './slices/cuttingTechnologiesSlice'
import materialsReducer from './slices/materialsSlice'
import miscItemsReducer from './slices/miscItemsSlice'
import organisationReducer from './slices/organisationSlice'
import quoteItemsReducer from './slices/quoteItemsSlice'
import ratesReducer from './slices/ratesSlice'
import rateTablesReducer from './slices/rateTablesSlice'
import sheetsReducer from './slices/sheetsSlice'

const persistConfig = {
    key: 'qt',
    version: 4,
    storage,
    whitelist: ['displayQuotePricing', 'showDrawingDoctorLegend'],
}

const persistedAppReducer = persistReducer(persistConfig, appReducer)

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        [authProviderApi.reducerPath]: authProviderApi.reducer,
        [migrationApi.reducerPath]: migrationApi.reducer,
        [quickPartsApi.reducerPath]: quickPartsApi.reducer,
        appSlice: persistedAppReducer,
        contactsSlice: contactsReducer,
        customersSlice: customersReducer,
        cuttingTechnologiesSlice: cuttingTechnologiesReducer,
        materialsSlice: materialsReducer,
        miscItemsSlice: miscItemsReducer,
        organisationSlice: organisationReducer,
        quoteItemsSlice: quoteItemsReducer,
        ratesSlice: ratesReducer,
        rateTablesSlice: rateTablesReducer,
        sheetsSlice: sheetsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        })
            .concat(api.middleware)
            .concat(authProviderApi.middleware)
            .concat(migrationApi.middleware)
            .concat(quickPartsApi.middleware),
    devTools: process.env.NODE_ENV === 'development',
})

setupListeners(store.dispatch)

export const persistor = persistStore(store)
